import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import useActivityService, {
  DELETE_CRM_ACTIVITY_PERMISSION,
  UPDATE_CRM_ACTIVITY_PERMISSION,
} from 'domain/sales/shared/timeline/activity/crmActivityService';
import ActivityFields from 'domain/sales/shared/timeline/activity/ActivityTimelineRecordLayout/ActivityFields';
import { useShowContext } from 'framework/show';
import PastDueMark from 'domain/sales/shared/timeline/activity/ActivityTimelineRecordLayout/PastDueMark';
import { Collapsible } from 'framework/ui/field';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import useTransferActivityService from 'domain/sales/shared/timeline/activity/shared/transferActivityService';
import TransferCrmActivityToAnotherEntityButton from 'domain/sales/shared/timeline/activity/shared/Button/TransferCrmActivityToAnotherEntityButton';
import transferActivityValidation from '../shared/transferActivityValidation';
import { useOpportunityId } from 'domain/shared/opportunity';
import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';
import { DeleteTimelineRecordButton, EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { PinTimelineButton } from 'domain/shared/timeline';

const ActivityTimelineRecordLayout = ({ onEdit, isPinned, ...props }: any) => {
  const opportunityId = useOpportunityId();
  const { deleteById } = useActivityService();
  const { transferActivity } = useTransferActivityService();
  const { updateInList, pinTimelineAction }: TimelineContextData = useListContext();

  const { data } = useShowContext();
  const timelineId = data.getValueBySource('timelineId');

  const buttons = [
    <EditTimelineRecordButton permissionToCheck={UPDATE_CRM_ACTIVITY_PERMISSION} key="edit" onEdit={onEdit} />,
    <TransferCrmActivityToAnotherEntityButton
      key="transfer"
      permissionToCheck={UPDATE_CRM_ACTIVITY_PERMISSION}
      submitFormFunc={values => transferActivity(data.getValueBySource('id'), values)}
      timelineId={data.getValueBySource('timelineId')}
      modalTitle="Transfer CRM activity to another entity"
      getValidationSchemaFunc={() => Promise.resolve(transferActivityValidation)}
      isApplicable={!!data.getValueBySource('internetMessageId')}
    />,
    <DeleteTimelineRecordButton
      permissionToCheck={DELETE_CRM_ACTIVITY_PERMISSION}
      deleteMethod={deleteById}
      key="add"
      id={data.getValueBySource('id')}
      timelineId={data.getValueBySource('timelineId')}
      entityName="note"
    />,
  ];

  const actions = [
    <PinTimelineButton
      pinStatus={isPinned}
      pinMethod={async () => {
        const response = await pinTimelineAction!(opportunityId, timelineId, !isPinned);
        updateInList!(response?.id, response);
      }}
    />,
    <PastDueMark />,
  ];

  const type = data.getValueBySource('activityType');

  return (
    <BaseTimelineRecordLayout
      fields={
        <Collapsible>
          <ActivityFields entity={data} />
        </Collapsible>
      }
      entity={data}
      buttons={buttons}
      actions={actions}
      timelineType={TimelineType[type]}
      {...props}
    />
  );
};

export default ActivityTimelineRecordLayout;
